import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button, Group, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { ChevronLeft, type LucideIcon } from "lucide-react";

export interface AreaHeaderProps {
  icon: LucideIcon;
  title: string;
  description?: ReactNode;
  /** The landing page this area belongs to, e.g. `/faq` or `/settings`. */
  backTo: string;
  backLabel: string;
}

/** The header of one area's page (an Office Guide category, a Settings area):
 *  icon and title, a way back to the landing grid, and an optional line of
 *  description. The counterpart of `AreaTile`. */
export function AreaHeader({ icon: Icon, title, description, backTo, backLabel }: AreaHeaderProps) {
  return (
    <Stack gap={4}>
      <Group justify="space-between" align="center" wrap="nowrap">
        <Group gap="sm" align="center" wrap="nowrap" style={{ minWidth: 0 }}>
          <ThemeIcon variant="light" size={36} radius="md">
            <Icon size={20} />
          </ThemeIcon>
          <Title order={3}>{title}</Title>
        </Group>
        <Button component={Link} to={backTo} variant="subtle" leftSection={<ChevronLeft size={16} />} style={{ flexShrink: 0 }}>
          {backLabel}
        </Button>
      </Group>
      {description && (
        <Text fz="sm" c="dimmed">
          {description}
        </Text>
      )}
    </Stack>
  );
}
